import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import type { LifecycleActorRole } from "./lifecycleWorkspace";

type LifecycleShellState = {
  actorRole?: LifecycleActorRole;
  viewingRole?: LifecycleActorRole;
  previewing: boolean;
  canPreview: boolean;
  setViewingRole: (role: LifecycleActorRole) => void;
  stageSummary?: any;
};

const LifecycleShellContext = createContext<LifecycleShellState | undefined>(undefined);

export function LifecycleShellProvider({ actorRole, stageSummary, children }: { actorRole?: LifecycleActorRole; stageSummary?: any; children: ReactNode }) {
  const [viewingRole, setViewingRole] = useState<LifecycleActorRole | undefined>(actorRole);
  useEffect(() => setViewingRole(actorRole), [actorRole]);
  const canPreview = actorRole === "admin";
  const value = useMemo(() => ({ actorRole, viewingRole: viewingRole ?? actorRole, previewing: canPreview && viewingRole !== "admin", canPreview, setViewingRole, stageSummary }), [actorRole, canPreview, stageSummary, viewingRole]);
  return <LifecycleShellContext.Provider value={value}>{children}</LifecycleShellContext.Provider>;
}

export function useLifecycleShell() {
  return useContext(LifecycleShellContext);
}
